import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchLedgeGroup } from "./API";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  applyTrimOnArray,
  applyTrimOnObjectValues,
  setKeyboardShortcuts,
  getRowOfRT,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import CtART from "./CustomTool/ResponsiveTable";

class LedgerGroup extends Component {
  state = {
    GroupHeader: [
      { GroupHeader: "Trading" },
      { GroupHeader: "Profit-Loss" },
      { GroupHeader: "Assets" },
      { GroupHeader: "Liability" },
      { GroupHeader: "None" },
    ],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_ledgergroupidsrno", label: "SR NO", hide: true },
      { id: "vac_groupname", label: "Group Name" },
      { id: "vac_groupheader", label: "Group Header" },
    ],
    columnsdata: [
      { accessorKey: "bint_ledgergroupidsrno", header: "SR NO", hide: true },
      { accessorKey: "vac_groupname", header: "Group Name" },
      { accessorKey: "vac_groupheader", header: "Group Header" },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "LedgerGroup:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "LedgerGroup:",
        actionType: "AlertResponsive",
      },
    ],
    keyColumn: ["bint_ledgergroupidsrno", "vac_groupname", "vac_groupheader"],
    formData: {
      bint_acid: "",
      txtCompany: "",
      EditLedgerGroupIdSrNo: "",
      txtGroupName: "",
      cmbGroupHeader: "",
    },
    searchData: {
      vac_groupname: "",
      vac_groupheader: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading &&
        (document.title = "RiTe Account : Ledger Group");
    }
    this.props.setActiveMenu("LedgerGroup");
    this.ShortCut();
    this.setSearchColumns();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    // this.getInfo();
  }
  componentWillUnmount() {
    this.removeShortCut();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchInputChangeTrim = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value.trim(),
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row, index) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_groupname.length === 0 ||
            (row["vac_groupname"] &&
              row["vac_groupname"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_groupname.toLowerCase()
                ))) &&
          (this.state.searchData.vac_groupheader === "" ||
            (row["vac_groupheader"] &&
              row["vac_groupheader"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_groupheader.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState({
        searchOpen,
        searchRows,
        searchRowsCount,
        counter: this.state.counter + 1,
      });
    } else {
      this.setState({ searchOpen });
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (row) => {
    const EditLedgerGroupIdSrNo = row.bint_ledgergroupidsrno,
      txtGroupName = row.vac_groupname,
      cmbGroupHeader = row.vac_groupheader,
      actionName = row.actionName;
    if (actionName == "Edit") {
      this.setState({
        formData: {
          ...this.state.formData,
          EditLedgerGroupIdSrNo,
          txtGroupName,
          cmbGroupHeader,
        },
      });
    } else if (actionName == "Delete") {
      this.DeleteData(EditLedgerGroupIdSrNo, txtGroupName);
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_ledgergroupidsrno", "vac_groupname"]);
    const EditLedgerGroupIdSrNo = row.bint_ledgergroupidsrno,
      txtGroupName = row.vac_groupname;
    this.DeleteData(EditLedgerGroupIdSrNo, txtGroupName);
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_ledgergroupidsrno",
      "vac_groupname",
      "vac_groupheader",
    ]);
    const EditLedgerGroupIdSrNo = row.bint_ledgergroupidsrno,
      txtGroupName = row.vac_groupname,
      cmbGroupHeader = row.vac_groupheader;
    this.setState({
      formData: {
        ...this.state.formData,
        EditLedgerGroupIdSrNo,
        txtGroupName,
        cmbGroupHeader,
      },
    });
  };

  //#endregion handle

  //#region function
  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.SaveLedgerGroup,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.EditLedgerGroupIdSrNo,
          this.state.formData.txtGroupName
        );
      }
      // this.saveSales(true)
    );
  };
  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      {
        handleOnclickSave: this.SaveLedgerGroup,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: () => {
          this.DeleteData(
            this.state.formData.EditLedgerGroupIdSrNo,
            this.state.formData.txtGroupName
          );
        },
      }

      // this.saveSales(true)
    );
  };
  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validatLegderGroup = () => {
    let result = false;
    if (this.state.formData.txtGroupName.length <= 0) {
      this.props.toastErrorMsg("Enter Group Name", "txtGroupName");
    } else if (this.state.formData.cmbGroupHeader.length <= 0) {
      this.props.toastErrorMsg("Enter Group Header", "cmbGroupHeader");
    } else {
      result = true;
    }
    return result;
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      { cType: "Lbl", id: "bint_ledgergroupidsrno" },
      {
        cType: "CtTxt",
        id: "vac_groupname",
        label: "Group Name",
        value: this.state.searchData.vac_groupname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_groupheader",
        items: this.state.GroupHeader,
        label: "Group Header",
        value: this.state.searchData.vac_groupheader,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130",
      }
    );
    this.setState({ searchColumns });
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LedgerGroupList",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchLedgeGroup(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          if (res.data.LedgerGroupList && res.data.LedgerGroupList.length > 0) {
            rows = res.data.LedgerGroupList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              dataLoadStatus,
              rows,
              rowsCount,
            },
            () => {
              if (this.props.refreshGroupNameList) {
                this.props.refreshGroupNameList(rows);
              }
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtGroupName").focus();
  };

  DeleteData = (EditLedgerGroupIdSrNo, StrLedgerGroup) => {
    if (EditLedgerGroupIdSrNo > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Ledger Group : " + StrLedgerGroup + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLedgerDetail(EditLedgerGroupIdSrNo);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  SaveLedgerGroup = () => {
    if (this.validatLegderGroup()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveLedgerGroup",
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          edit_ledgergroupidsrno: this.state.formData.EditLedgerGroupIdSrNo,
          vac_groupname: this.state.formData.txtGroupName,
          vac_groupheader: this.state.formData.cmbGroupHeader,
        };
        fetchLedgeGroup(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.getInfo();
              this.clearInfo(true);
            } else {
              this.setState({
                dataLoadStatus: true,
              });
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in SaveLedgerGroup.", error);
          });
      });
    }
  };

  clearInfo = () => {
    const bint_acid = "",
      txtCompany = "",
      EditLedgerGroupIdSrNo = "",
      txtGroupName = "",
      cmbGroupHeader = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_acid,
          txtCompany,
          EditLedgerGroupIdSrNo,
          txtGroupName,
          cmbGroupHeader,
        },
      },
      () => {
        document.getElementById("txtGroupName").focus();
      }
    );
  };

  DeleteLedgerDetail = (edit_ledgergroupidsrno) => {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteLedgerGroup",
        bint_acid: localStorage.getItem("acid"),
        edit_ledgergroupidsrno: edit_ledgergroupidsrno,
      };
      fetchLedgeGroup(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState({ ARD: null }, () => {
              this.getInfo();
              this.clearInfo(true);
            });
          } else {
            this.setState({ dataLoadStatus: true });
          }
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in LedgerGroup. " + error
          );
        });
    });
    return false;
  };
  //#endregion handle

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading == true && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "30px", color: "#515151" }}
            >
              <b>Ledger Group</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtGroupName"
                  value={this.state.formData.txtGroupName}
                  label="Group Name*"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbGroupHeader"
                />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbGroupHeader"
                  label="Group Header*"
                  value={this.state.formData.cmbGroupHeader}
                  handleOnChange={this.handleOnChange}
                  items={this.state.GroupHeader}
                  width={150}
                  colID="GroupHeader"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtBtn
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.SaveLedgerGroup();
                    });
                  }}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant="outlined"
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.EditLedgerGroupIdSrNo,
                      this.state.formData.txtGroupName
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          // toolTipNewEntry='New Product Entry'
        /> */}
        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("LeaderGroup")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            {
              label: "Delete",
              onClick: this.handleARDonActionClick_Delete,
              icon: "delete",
              className: "delete-button",
            },
            // this.props.userPrivilege["Entry:Proposal"] == "M"
            //   ? {
            //       label: "Delete",
            //       onClick: this.handleARDonActionClick_Delete,
            //       icon: "delete",
            //       className: "delete-button",
            //     }
            //   : "",
          ]}
          // tableButtonAction={[
          //   {
          //     label: "Sales Entry",
          //     onClick: this.handleOnNewEntryClick,
          //     addPluseIcon: true,
          //   },
          //   // this.props.userPrivilege["Entry:Proposal"] != "R"
          //   //   ? {
          //   //       label: "Add New Proposal",
          //   //       onClick: this.handleOnNewEntryClick,
          //   //       addPluseIcon: true,
          //   //     }
          //   //   : "",
          // ]}
          showColumnFilters={false}
          hideColIdList={["bint_ledgergroupidsrno"]}
          density={"compact"}
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(LedgerGroup)));
